/**
 * Whether this headset is being steered, or steering itself.
 *
 * One rule with two consequences, which is why it is a function rather than a
 * condition written twice: it decides whether the lectern offers a way forward
 * at all, and whether an arriving `session.state` moves this headset to the
 * step the class is on.
 *
 * Getting the second one wrong is invisible until somebody tries it. In a free
 * class `session.state.stepId` is where the *class* is, not where this student
 * is, so a headset that follows it is pulled back to the class step the
 * instant the student moves themselves -- they press Verder, arrive, and are
 * dragged home by the broadcast their own move caused.
 */
export type ClassControl = 'locked' | 'free';

export type SteerableState = {
  control?: string;
  paused?: boolean;
};

export function controlFor(state: SteerableState): ClassControl {
  // A paused class is a locked one: "eyes on me" is not the moment to let
  // thirty children wander off, and a Verder button the server would refuse
  // is worse than no button.
  return state.control === 'free' && state.paused !== true ? 'free' : 'locked';
}

/** True when the class's step is this headset's step. */
export function followsClass(state: SteerableState): boolean {
  return controlFor(state) === 'locked';
}
